<script setup lang="ts">
defineProps<{ size: number }>()
const mobile= useMobile()
</script>

<template>
  <div v-for="i in size" :key="i">
    <div class="_relative d_wmax500 _hidden _a1" style="padding-bottom: 100%;"><UiLoadingBox inset :radius="mobile ? undefined : '_br14'" /></div>
    <div class="_h80 d_mt2 d_mb1">
      <UiLoadingBox :repeat="3" class="_mt06 _mb06 _w60" height="_h14" radius="r2" />
    </div>
  </div>
</template>
